import slice from './slice';

export const { setConfirm } = slice.actions;
